function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 22a1 1 0 110-2v-1.515a7 7 0 011.837-4.726l.213-.223.829-.829a1 1 0 00.083-1.32l-.083-.094-.829-.829a7 7 0 01-2.043-4.64L6 5.513V5a1 1 0 010-2h12a1 1 0 110 2v.842a6.857 6.857 0 01-2.133 4.97l-.209.19-.39.343-.05.045a1 1 0 00-.082 1.32l.083.095.73.73a7 7 0 012.044 4.642l.007.308V20a1 1 0 110 2H6zM16 5H8v.515a5 5 0 001.112 3.143l.17.2.182.192.829.829a3 3 0 01.135 4.098l-.135.144-.829.829a5 5 0 00-1.44 3.038l3.082-1.54a2 2 0 011.788 0l3.081 1.54a5 5 0 00-1.085-2.644l-.172-.202-.182-.192-.731-.731a3 3 0 010-4.243l.071-.07.074-.066.392-.343a4.857 4.857 0 001.652-3.408L16 5.842V5zm-2 1.5a3 3 0 01-1.2 2.4l-.8.6-.8-.6A3 3 0 0110 6.5h4z",
    fill: "#292A2B"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-clocksand.svg";